function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "cls-header-profile",
  d: "M297.94,432.81a12.32,12.32,0,1,1,0-24.63h0a12.32,12.32,0,1,1,0,24.63Zm0-23.63A11.49,11.49,0,0,0,289.1,428a10.47,10.47,0,0,1,17.67,0,11.49,11.49,0,0,0-8.83-18.85Zm0,12a4.5,4.5,0,1,1,4.5-4.5A4.5,4.5,0,0,1,297.94,421.2Z",
  transform: "translate(-285.44 -408.19)"
});

var SvgNavUser = function SvgNavUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg_header_profile_icon",
    "data-name": "Layer 1",
    viewBox: "0 0 24.99 24.63",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav_user.8f29d36a.svg";
export { ForwardRef as ReactComponent };